module.exports = __webpack_public_path__ + "img/logo.8e23f6bf.png";